import { EmptyIcon } from "@/components/icons";
import { cn } from "cn";
import type { ComponentType, ReactNode } from "react";

/**
 * Lo que se enseña cuando no hay nada que enseñar.
 *
 * Existe para que las pantallas vacías se parezcan entre ellas: un icono
 * apagado, una frase, y --cuando lo hay-- qué hacer para que deje de estar
 * vacía. Repartido por cada pantalla, cada hueco acababa con su propio tono.
 *
 * El icono es decorativo y por eso NO lleva etiqueta: lo que dice ya lo dice
 * el texto que tiene al lado, y un lector de pantalla que lo anunciara solo
 * repetiría.
 */
export function EmptyState({
  icon: Icon = EmptyIcon,
  children,
  className,
}: {
  readonly icon?: ComponentType<{ className?: string }>;
  readonly children: ReactNode;
  readonly className?: string;
}) {
  return (
    <div
      className={cn(
        "grid justify-items-center gap-2 px-4 py-8 text-center",
        className,
      )}
    >
      <Icon className="size-6 text-muted-foreground/60" aria-hidden />
      <p className="max-w-sm text-sm text-muted-foreground">{children}</p>
    </div>
  );
}
